import React from "react";
import tuzka from "../../assets/icons/tuzka.png";

export const Pencil = ({ ...props }) => {
  return <img src={tuzka} alt="Pencil" {...props} />;
};
